// Copy story template to clipboard
// https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText

document.querySelectorAll('.StoryTemplate').forEach((el) => {
  const content = el.querySelector('.StoryTemplate-content').textContent;
  const button = el.querySelector('.StoryTemplate-copy');

  button.addEventListener('click', (evt) => {
    navigator.clipboard.writeText(content).then(
      // Success
      () => {
        button.classList.add('copied');
        button.setAttribute('aria-label', 'Copied.');
        // Remove class after a short delay
        setTimeout(() => {
          button.classList.remove('copied');
          button.setAttribute('aria-label', 'Copy Story Template');
        }, 3000);
      },
      // Failure
      () => {
        button.classList.remove('copied');
      }
    )
  })
});
